/**
 * Сообщения командного чата (TG-группа «Внутренняя Сбер Авто X Carlink»),
 * привязанные к лиду. Таблицу public.team_chat_messages наполняет edge
 * tg-ingest (бот @avs_carlink_bot), привязку ставит триггер БД (точные
 * признаки) и edge team-chat-ai (ИИ); консоль читает (RLS: admin/dispatcher)
 * и правит привязку через RPC team_chat_assign / team_chat_ignore.
 */
import { createClient } from '@/api/supabase'

export type TeamChatLinkMethod = 'console' | 'crm_id' | 'lot' | 'report' | 'vin' | 'plate' | 'reply' | 'manual' | 'ai'

export interface TeamChatMessage {
  id: number
  /** telegram — собрано ботом; tg_export — импорт из выгрузки Telegram Desktop. */
  source: string
  chat_id: number
  message_id: number
  sent_at: string
  edited_at: string | null
  from_name: string | null
  text: string | null
  forward_from: string | null
  media_type: string | null
  file_name: string | null
  link_method: TeamChatLinkMethod | null
  link_confidence: number | null
  ai_note: string | null
  ai_attachment_text: string | null
  /** Сообщение, на которое это ответ (как его прислал Telegram). */
  reply: { text?: string; caption?: string; from?: { first_name?: string; last_name?: string } } | null
}

const MESSAGE_COLUMNS =
  'id, source, chat_id, message_id, sent_at, edited_at, from_name, text, forward_from, media_type, file_name, link_method, link_confidence, ai_note, ai_attachment_text, reply:raw->reply_to_message'

export async function getTeamChatMessages(leadId: string): Promise<TeamChatMessage[]> {
  const supabase = createClient()
  const { data, error } = await supabase
    .from('team_chat_messages')
    .select(MESSAGE_COLUMNS)
    .eq('lead_id', leadId)
    .order('sent_at', { ascending: true })
  if (error) throw new Error(error.message)
  return (data as unknown as TeamChatMessage[]) ?? []
}

/** Привязать вручную; leadId = null — «не тот лид» (снять привязку). */
export async function assignTeamChatMessage(messageId: number, leadId: string | null): Promise<void> {
  const { error } = await createClient().rpc('team_chat_assign', { p_message_id: messageId, p_lead_id: leadId })
  if (error) throw new Error(error.message)
}

/**
 * Ссылка на сообщение в супергруппе: t.me/c/<id без -100>/<message_id>.
 * У импортированных из выгрузки номера свои — ссылки нет.
 */
export function teamChatMessageUrl(m: Pick<TeamChatMessage, 'source' | 'chat_id' | 'message_id'>): string | null {
  if (m.source !== 'telegram') return null
  return `https://t.me/c/${String(m.chat_id).replace(/^-100/, '')}/${m.message_id}`
}
